module.exports = __webpack_public_path__ + "static/media/galerija_2017 (4).b01ce422.jpg";